import { httpClient } from '@/services/http/httpClient'

type Params = {
  id: string
  name: string
  departmentId: string
  areaId: string
  email?: string
  registration?: string
  password?: string
  isAdmin: boolean
  isManager: boolean
  isProjectAdmin?: boolean
}

export async function update({
  id,
  name,
  areaId,
  departmentId,
  email,
  registration,
  password,
  isAdmin,
  isManager,
  isProjectAdmin,
}: Params): Promise<void> {
  await httpClient.put(`/users/${id}`, {
    name,
    areaId,
    departamentId: departmentId,
    ...(email && { email }),
    ...(registration && { registration }),
    ...(password && { password }),
    isAdmin,
    isManager,
    isProjectAdmin: isProjectAdmin ?? false,
  })
}
